// Age-band presentation metadata.
// Each band gets a name, a two-stop gradient (Cambridge YLE pastel palette),
// a lucide icon key, and a short human tagline for the landing card.

import { Sprout, Sparkles, Compass, Cpu, BrainCircuit } from "lucide-react";

export const BANDS = [
  {
    id: "age_6-7",
    label: "Ages 6–7",
    tagline: "First patterns, first algorithms — through play.",
    gradient: ["#fbe7dc", "#f4b39a"], // dusty rose → warm terracotta
    accent: "#c97b5a",
    Icon: Sprout,
  },
  {
    id: "age_8-9",
    label: "Ages 8–9",
    tagline: "Variables, loops, and a first look at data.",
    gradient: ["#f7f1dc", "#d9d38b"], // cream → sage-cream
    accent: "#8a9a5b",
    Icon: Sparkles,
  },
  {
    id: "age_10-12",
    label: "Ages 10–12",
    tagline: "Pseudocode, functions, and datasets that teach.",
    gradient: ["#e4f0ea", "#a8c9c1"], // pale teal → muted teal
    accent: "#5b9a94",
    Icon: Compass,
  },
  {
    id: "age_13-14",
    label: "Ages 13–14",
    tagline: "Algorithms with intent — search, sort, ethics.",
    gradient: ["#efeadf", "#c9b58c"], // parchment → antique gold
    accent: "#a68858",
    Icon: Cpu,
  },
  {
    id: "age_15-17",
    label: "Ages 15–17",
    tagline: "Formal algorithms, the maths inside AI, and society.",
    gradient: ["#eae2dc", "#b19a8c"], // sandstone → mocha
    accent: "#7a5d4a",
    Icon: BrainCircuit,
  },
];

export function findBand(id) {
  return BANDS.find((b) => b.id === id) || null;
}

export function pretty(id) {
  return findBand(id)?.label || id;
}
